import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { Editor } from "components/shared/Editor";
import { addBlog, getBlogCategories } from "store/actions";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { getId } from "helpers/functions";
import ImageUploadAr from "./ImageUploadAr";
import ImageUploadEn from "./ImageUploadEn";

const AddBlog = () => {
  const [selectedImageAr, setSelectedImageAr] = useState();
  const [selectedImageEn, setSelectedImageEn] = useState();
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { locale } = useIntl();

  const { blogCategories } = useSelector((state) => state.blogCategories);
  // const { languages } = useSelector((state) => state.languages);

  const { blogTags } = useSelector((state) => state.blogs) || {};

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    dispatch(getBlogCategories());
    // dispatch(getTags());
  }, [dispatch]);

  const renderCategoriesOptions = blogCategories?.map((category) => (
    <option value={getId(category)}>{category?.title?.[locale]}</option>
  ));

  const onSubmit = (data) => {
    if (selectedImageAr?.path)
      data.imageAr = `uploads/${selectedImageAr.path.split("/").pop()}`;
    if (selectedImageEn?.path)
      data.imageEn = `uploads/${selectedImageEn.path.split("/").pop()}`;
    // if (selectedImageAr && selectedImageAr.path)
    //   data["imageAr"] = selectedImageAr.path;
    // if (selectedImageEn && selectedImageEn.path)
    //   data["imageEn"] = selectedImageEn.path;
    // // data.image = "uploads/" + data?.image?.split("/").pop();
    // data.imageAr = "uploads/" + data?.image?.split("/").pop();
    // data.imageEn = "uploads/" + data?.image?.split("/").pop();
    data.description = description;
    data.tags = tags;

    dispatch(addBlog({ data, navigate }));
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="addBlog" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="imageAr" />
                      </h5>
                      <ImageUploadAr
                        selectedImageAr={selectedImageAr}
                        setSelectedImageAr={setSelectedImageAr}
                        accept="image/*, video/*"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="imageEn" />
                      </h5>
                      <ImageUploadEn
                        selectedImageEn={selectedImageEn}
                        setSelectedImageEn={setSelectedImageEn}
                        accept="image/*, video/*"
                      />
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div className="form-group required">
                      <h5>التصنيف</h5>
                      <div>
                        <select
                          className="form-control"
                          {...register("category", { required: true })}
                        >
                          <option value="">اختر التصنيف</option>
                          {renderCategoriesOptions}
                        </select>
                      </div>
                      <p className="error-hint">
                        {errors.category?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" /> (
                        <FormattedMessage id="arabic" />)
                      </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          {...register("title.ar", {
                            required: true,
                          })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors.title?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" /> (
                        <FormattedMessage id="english" />)
                      </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          {...register("title.en", {
                            required: true,
                          })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors.title?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (
                        <FormattedMessage id="arabic" />)
                      </h5>
                      <div>
                        <Controller
                          control={control}
                          name="description.ar"
                          render={({ field: { value } }) => (
                            <Editor
                              initialValue=""
                              onChange={(e, editor) => {
                                const data = editor.getContent();
                                setDescription({
                                  ...description,
                                  ar: data,
                                });
                              }}
                              tinymceScriptSrc="https://cdn.tiny.cloud/1/qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc/tinymce/5-stable/tinymce.min.js"
                            />
                          )}
                        />
                        <p className="error-hint">
                          {errors.description?.ar?.type === "required" && (
                            <FormattedMessage id="required" />
                          )}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (
                        <FormattedMessage id="english" />)
                      </h5>
                      <div>
                        <Controller
                          control={control}
                          name="description.en"
                          render={({ field: { value } }) => (
                            <Editor
                              initialValue=""
                              onChange={(e, editor) => {
                                const data = editor.getContent();
                                setDescription({
                                  ...description,
                                  en: data,
                                });
                              }}
                              tinymceScriptSrc="https://cdn.tiny.cloud/1/qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc/tinymce/5-stable/tinymce.min.js"
                            />
                          )}
                        />
                        <p className="error-hint">
                          {errors.description?.en?.type === "required" && (
                            <FormattedMessage id="required" />
                          )}
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="keywords" />
                      </h5>
                      <div>
                        <Controller
                          control={control}
                          name="tags"
                          render={({
                            field: { onChange, value, selected },
                          }) => (
                            <CreatableSelect
                              isMulti
                              isRtl={true}
                              className="basic-single creatable-select"
                              classNamePrefix="select"
                              placeholder="اضف كلمات دلالية"
                              onChange={(selected) => {
                                const newTags = selected.map(
                                  (tag) => tag.label
                                );

                                setTags(newTags);
                              }}
                              options={blogTags.map((tag) => ({
                                value: tag,
                                label: tag,
                              }))}
                            />
                          )}
                        />
                      </div>
                      <p className="error-hint">
                        {errors.tags?.type === "required" &&
                          "يرجي ادخال الكلمات الدلالية"}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col lg={4} xs={12}>
                <div className="form-group mt-3">
                  <button type="submit" className="btn btn-blue">
                    <FormattedMessage id="add" />
                  </button>
                </div>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBlog;
